/**
 * Fixed category constants used throughout the application
 */

export const CATEGORY_DESAFIO = 'DESAFIO';
